import React from 'react'
import Style from './createConnector.module.css'

const Question = ({ question, value, onChange }) => {
    const id = `question-${question.id}`
    const options = question.questionOptions || []
    return (
        <div className={Style.field}>
            <label htmlFor={id} className={Style.label}>{question.text}</label>
            {question.type === 'Dropdown' ? (
                <select id={id} className={`form-control ${Style.select}`} value={value} onChange={(event) => onChange(event.target.value)}>
                    <option value="">Select an option</option>
                    {options.map((option) => <option key={option.code} value={option.code}>{option.displayName}</option>)}
                </select>
            ) : (
                <input
                    id={id}
                    type="text"
                    className={`form-control ${Style.input}`}
                    value={value}
                    autoComplete="off"
                    onChange={(event) => onChange(event.target.value)}
                />
            )}
        </div>
    )
}

const DetailsStep = ({ integration, plan, productTypeName, questions, answers, onAnswer }) => (
    <div className={Style.split}>
        <section className={Style.section} aria-labelledby="details-questions">
            <h3 id="details-questions" className={Style.sectionTitle}>Prerequisites</h3>
            <div className={Style.fields}>
                {questions.map((question) => (
                    <Question
                        key={question.id}
                        question={question}
                        value={answers[question.id] || ''}
                        onChange={(value) => onAnswer(question.id, value)}
                    />
                ))}
            </div>
        </section>
        <section className={Style.section} aria-labelledby="details-summary">
            <h3 id="details-summary" className={Style.sectionTitle}>Summary</h3>
            <dl className={Style.summary}>
                <div><dt>{integration.source.shortName} version</dt><dd>{plan.sourceVersion}</dd></div>
                <div><dt>{integration.target.shortName} version</dt><dd>{plan.targetVersion}</dd></div>
                <div><dt>Product type</dt><dd>{productTypeName || '—'}</dd></div>
            </dl>
        </section>
    </div>
)

export default DetailsStep
